import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Geluid, Kruis } from '../Iconen.jsx';

/**
 * Minigame: Krabbelry!
 *
 * In de code heet dit `mem`/`memory`, met de collectie `paal_memory`. Dat blijft zo;
 * zie sectie 13 van CLAUDE.md.
 *
 * Twaalf kaartjes in vier kolommen, en op elk kaartje een echte krabbel van de
 * paal. Alleen stilstaande en vierkante krabbels: een bewegende verraadt zichzelf
 * doordat hij beweegt.
 *
 * Dezelfde behuizing als Krabbelworm, zodat de twee spelletjes familie zijn: de
 * lila plaat met een rand van drie, de titelbalk met de geluidsknop en het
 * kruisje, en de stand op één regel onder het speelveld.
 */
export default function Memory({ v }) {
  if (!v.showMemory) return null;
  return (
    <div className="gp-laag" onClick={v.closeMemory} style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }}>
      <div className="gp-venster" onClick={v.stopProp} style={css(v.memPanelStyle)}>
        <div style={{ "display": "flex", "alignItems": "center", "gap": "12px", "flex": "0 0 auto" }}>
          <div style={css(v.memTitelStyle)}>
            <Interp v={v.memTitel} />
          </div>
          <button onClick={v.toggleSpelStil} title={v.spelStilTitel} aria-label={v.spelStilTitel} aria-pressed={v.spelStil ? 'true' : 'false'} style={css(v.sluitStyle)}>
            <Geluid maat={22} stil={v.spelStil} />
          </button>
          <button onClick={v.closeMemory} title="Sluiten" style={css(v.sluitStyle)}>
            <Kruis maat={22} />
          </button>
        </div>

        <div style={css(v.memConsoleStyle)}>
          <div style={{ "position": "relative", "minWidth": "0" }}>
            <div style={css(v.memRasterStyle)}>
              {toList(v.memKaarten).map((k, $index) => (
                <React.Fragment key={$index}>
                  <button onClick={k?.onClick} className="gp-btn" title={k?.titel} aria-label={k?.titel} style={css(k?.style)}>
                    {k?.zichtbaar
                      ? <img alt="" src={k?.src} style={css(k?.imgStyle)} />
                      : <span style={css(k?.achterStyle)}>?</span>}
                  </button>
                </React.Fragment>
              ))}
            </div>
            {v.showMemOver ? (
              <div style={css(v.memOverStyle)}>
                <div style={css(v.memPlakStyle)}>
                  <div style={css(v.memOverKopStyle)}>Gevonden!</div>
                </div>
                <div style={css(v.memPlakStyle)}>
                  <div style={css(v.memOverRegelStyle)}>
                    <span style={css(v.memOverLabelStyle)}>Jouw beurt:</span>
                    <span style={css(v.memOverGetalStyle)}><Interp v={v.memZettenLabel} /></span>
                  </div>
                  {v.showMemBest ? (
                    <div style={css(v.memOverRegelStyle)}>
                      <span style={css(v.memOverLabelStyle)}><Interp v={v.memBestLabel} /></span>
                    </div>
                  ) : null}
                  <div style={css(v.memLijstStyle)}>
                    {toList(v.memTop).map((r, $index) => (
                      <React.Fragment key={$index}>
                        <div style={css(r?.rijStyle)}>
                          <span style={css(r?.plekStyle)}><Interp v={r?.plek} /></span>
                          <span style={css(r?.naamStyle)}><Interp v={r?.name} /></span>
                          <span style={css(r?.scoreStyle)}><Interp v={r?.score} /></span>
                        </div>
                      </React.Fragment>
                    ))}
                    {v.showMemLijstLeeg ? (
                      <div style={css(v.memLijstLeegStyle)}><Interp v={v.memLijstLeeg} /></div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          {v.showMemLeeg ? (
            <div style={css(v.memLeegStyle)}><Interp v={v.memLeeg} /></div>
          ) : null}

          <button onClick={v.memOpnieuw} className="gp-btn pink" style={css(v.memOpnieuwStyle)}>
            <Interp v={v.memOpnieuwLabel} />
          </button>
        </div>
      </div>
    </div>
  );
}
